import React from 'react'
import { PARAMS_DIVIDER } from '../../../constants/default_constants'

export default ({ store, attr, val }) => {
  const right = store.cv.record.get('rights').find(i => i.id === val)
  return right
    ? (<span title={store.__('ID, license period, platform, rights type, tier')}>
      {right.id || store.__('new')}
      {right.start_license_period ? PARAMS_DIVIDER + right.start_license_period.split('T')[0] : '-'}
      {' / '}
      {right.end_license_period ? right.end_license_period.split('T')[0] : '-'}
      {right.regions ? PARAMS_DIVIDER + right.regions : null}
      {right.platform
        ? (store.options.has('Platforms')
          ? PARAMS_DIVIDER + store.options.get('Platforms').find((j) => j.value === right.platform).text
          : PARAMS_DIVIDER + right.platform)
        : null}
      {right.right_type
        ? (store.options.has('RightsTypes')
          ? PARAMS_DIVIDER + store.options.get('RightsTypes').find((j) => j.value === right.right_type).text
          : PARAMS_DIVIDER + right.right_type)
        : null}
      {right.pricing_tier ? PARAMS_DIVIDER + right.pricing_tier : null}
    </span>)
    : null
}
